import React, {useState} from 'react';
import logo from './../../asset/logo.svg'
import {NavLink, useHistory} from "react-router-dom";
import MenuIcon from '@material-ui/icons/Menu';
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from '@material-ui/core/Fade';
import {MuiThemeProvider} from "@material-ui/core/styles/";
import {PageWithoutSidebar} from "../common/PageWithoutSidebar/PageWithoutSidebar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {withStyles} from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";


export const CustomTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, .9)',
        fontSize: theme.typography.pxToRem(12),
        bottom: "0",
    },
    arrow: {
        color: 'rgba(0, 0, 0, .9)',
    },
}))(Tooltip);


const pathesWithSearch = ["booking", "reviews", "invoices", "contracts", "busy-calendar", "contract"]

const ObjectInfoLine = ({objectId, objectName, publicLink}) => {

    return (
        <div className="navbar__object-info-line">
            <div className="navbar__object-name d-none d-sm-block">{objectName}</div>
            <div className="navbar__object-id badge bg-success me-0 me-sm-2">id: {objectId}</div>

            {publicLink &&
            <div className="navbar__object-link">
                <Button component={"a"} href={publicLink} target="_blank">
                    <FontAwesomeIcon icon={"share"} className="me-1"/>На
                    страницу объекта</Button>
            </div>
            }


        </div>
    )
}

const Header = (props) => {
    const {toggleLeftMenu, leftMenuActive, userRole, logoutUser, objectId, objectName, objectLink, headerSubtitle, baseUrl, publicLink} = props

    const [anchorUserMenu, setAnchorUserMenu] = useState(null)
    const handleClickBtnUserMenu = (event) => {
        setAnchorUserMenu(event.currentTarget)
    };
    const handleCloseUserMenu = () => {
        setAnchorUserMenu(null)
    };


    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handelLogout = () => {
        logoutUser()
    }

    const showAddition = () => {
        return !PageWithoutSidebar.includes(props.location.pathname)
    }


    const showSearchObjects = () => {
        return (props.match.params.objectId || props.match.params.contractId) && userRole === "MODERATOR" && pathesWithSearch.includes(props.location.pathname.split('/')[2])
    }

    const toggleLeftMenuHandler = () => {
        toggleLeftMenu(!leftMenuActive)
    }

    const history = useHistory()
    return (<header>
            <nav className="navbar navbar-expand-lg py-0" role="navigation">
                <div className="container-fluid justify-content-start h-100">
                    {showAddition()
                        ? <Button className="navbar-toggler" onClick={toggleLeftMenuHandler}>
                            <MenuIcon/>
                            <span>меню</span>
                        </Button>
                        : null}

                    <div className="logo-wrp">
                        <a className="navbar-brand d-flex me-2" href={baseUrl}>
                            <img
                                src={logo} alt="Едем-в-Гости.ру"/>
                        </a>
                        <span>Личный кабинет</span>
                    </div>

                    {showAddition() && userRole === "MODERATOR"
                        ? <Button component={'a'} target="_blank" href={`${baseUrl}/bitrix`}
                                  className="d-none d-sm-flex nav-btns me-2">
                            <span><FontAwesomeIcon icon={"users-cog"}/></span>
                            <span className="nav-btns__name">Админка</span>
                        </Button>
                        : null}

                    {showSearchObjects()
                        ? <Button onClick={history.goBack}
                                  className="d-none d-sm-flex nav-btns me-2">
                            <span><FontAwesomeIcon icon={"search"}/></span>
                            <span className="nav-btns__name">Поиск</span>
                        </Button>
                        : null
                    }

                    {/*TODO в разработке "Уведомления"*/}
                    {/* {showAddition()
                        ? <>
                            <CustomTooltip title={"Раскрыть панель уведомлений"} arrow placement="bottom">
                                <StyledIconButton className="notifications  ms-auto me-1"
                                                  aria-label="cart"
                                                  onClick={handleClick}>
                                    <StyledBadge badgeContent={2} color="secondary">
                                        <NotificationsIcon/>
                                    </StyledBadge>
                                </StyledIconButton>
                            </CustomTooltip>
                            <Popover
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <List dense={true} className="notifications-paper"
                                      style={{minWidth: "300px", maxWidth: "350px", width: "100%"}}>
                                    <ListItem button component={NavLink} to="/lk">
                                        <ListItemIcon>
                                            <NotificationsIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Подтвердите аккаунт" secondary="Вам необходимо подтвердить ваш аккаунт потому что так надо"/>

                                    </ListItem>
                                    <Divider />
                                    <ListItem button component={NavLink} to="/lk">
                                        <ListItemIcon>
                                            <NotificationsIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Подтвердите электронную почту" secondary="Вам необходимо подтвердить вашу электронную почту потому что так надо"/>
                                    </ListItem>
                                </List>
                            </Popover>
                        </>
                        : null}*/}

                    {/*TODO в разработке "Помощь"*/}
                    {/*<Button component={NavLink} to={"/lk/faq"}
                            className={`header-settings d-none d-sm-flex nav-btns ms-auto`}
                            aria-controls="fade-menu" aria-haspopup="true">
                        <span><FontAwesomeIcon icon={"info"}/></span>
                        <span className="nav-btns__name">Помощь</span>
                    </Button>*/}

                    {showAddition() && <>
                            <Button component={"a"}
                                    className="dropdown-toggle header-settings ms-auto d-none d-sm-flex nav-btns"
                                    aria-controls="fade-menu" aria-haspopup="true" onClick={handleClickBtnUserMenu}>
                                <span><FontAwesomeIcon icon={"user"}/></span>
                                <span className="nav-btns__name">Профиль</span>
                            </Button>
                            <Menu
                                id="fade-menu"
                                anchorEl={anchorUserMenu}
                                getContentAnchorEl={null}
                                keepMounted
                                open={Boolean(anchorUserMenu)}
                                onClose={handleCloseUserMenu}
                                TransitionComponent={Fade}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                            >
                                <MenuItem component={NavLink} to={"/lk/profile"} className="py-2 mb-1"><FontAwesomeIcon icon={"user-cog"}
                                                                                                  className="me-1"/> Настройки</MenuItem>
                                <MenuItem onClick={handelLogout} className="py-2"><FontAwesomeIcon icon={"sign-out-alt"}
                                                                                  className="me-1"/> Выход</MenuItem>
                            </Menu>

                        </>}
                </div>
            </nav>


            {headerSubtitle && <ObjectInfoLine objectId={objectId} objectName={objectName} publicLink={publicLink}/>}

        </header>

    );
}

export default Header;